import React, { useEffect } from 'react'
import { isFeatureEnabled } from '@/helpers/isFeatureEnabled'
import { AMPLITUDE_API_KEY } from '@/services/Configuration'

const AmplitudeAnalytics: React.FC = () => {
  useEffect(() => {
    if (isFeatureEnabled('isAmplitudeEnabled')) {
      window?.amplitude?.add(window.sessionReplay.plugin({ sampleRate: 1 }))
      window?.amplitude?.init(AMPLITUDE_API_KEY, {
        autocapture: {
          fileDownloads: false,
        },
      })
    }
  }, [])

  if (!isFeatureEnabled('isAmplitudeEnabled')) {
    return null
  }

  return (
    <>
      <link rel="preload" href="https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz" as="script" />
      <link rel="preload" href="https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz" as="script" />
      <script
        id="amplitude-analytics"
        src="https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz"
      />
      <script
        id="amplitude-session-replay"
        src="https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz"
      />
    </>
  )
}

export default AmplitudeAnalytics
